var map = {
	"./asyncData.js": "1bf4",
	"./carts.js": "f532",
	"./chat.js": "e041",
	"./config.js": "3fea",
	"./crudList.js": "0ada",
	"./currency.js": "c658",
	"./locale.js": "a6f3",
	"./something.js": "803b",
	"./ui.js": "cbe4",
	"./user.js": "c75e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b081";